import { cn } from '@/lib/cn';

interface LogoProps {
  variant?: 'mark' | 'full';
  className?: string;
  title?: string;
}

/**
 * Inline SVG approximation of the KIWASCO mark (oval with tap + water).
 * Keeps the bundle small and avoids asset wiring. Replace with the real
 * SVG export from the design team when ready.
 */
export function Logo({ variant = 'mark', className, title = 'KIWASCO' }: LogoProps) {
  if (variant === 'mark') {
    return (
      <svg
        viewBox="0 0 64 80"
        className={cn('text-navy-deep', className)}
        role="img"
        aria-label={title}
      >
        <ellipse
          cx="32"
          cy="40"
          rx="28"
          ry="36"
          fill="white"
          stroke="currentColor"
          strokeWidth="2.5"
        />
        {/* Tap */}
        <path
          d="M22 22 h18 v6 h-4 v6 h-10 v-6 h-4 z"
          fill="currentColor"
        />
        <rect x="29" y="34" width="6" height="10" fill="#0077B6" />
        {/* Hand catching water */}
        <path
          d="M18 50 q14 8 28 0"
          stroke="#2E7D32"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
        />
        {/* Waves */}
        <path
          d="M10 58 q11 -4 22 0 t22 0"
          stroke="#48CAE4"
          strokeWidth="2.5"
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M10 64 q11 -4 22 0 t22 0"
          stroke="#0077B6"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          opacity="0.6"
        />
      </svg>
    );
  }

  // Full variant — mark + wordmark below.
  return (
    <div className={cn('flex flex-col items-center', className)}>
      <Logo variant="mark" className="w-16 h-20" />
      <div className="mt-2 text-h2 tracking-wide text-navy-deep font-bold">
        KIWASCO
      </div>
      <div className="text-caption italic text-brand-blue-light">
        <span className="text-brand-blue">Refresh</span>{' '}
        <span className="text-brand-green">Life</span>
      </div>
    </div>
  );
}
